export const CardClickTypes = {
  provider: 'provider',
  share: 'share',
  pollDestination: 'poll_destination'
};

export const userFingerprintV1Cookie = 'vup-user-fingerprint';
export const userFingerprintV2Cookie = 'vup-user-fingerprint-v2';

export const CardTrackingCodeTypes = {
  load: 'load',
  destinationClick: 'destination_click',
  changeProvider: 'change_provider',
};
